import React, {FC, useEffect, useRef, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {ErrorMessage, Field, useFormik} from 'formik'
import {ICreateAccount, inits as initialValues} from '../CreateAccountWizardHelper'
import {newLineToSpace} from '../../../auth/components/middleware/newLineToSpace'
import {
  convertDate,
  validateInput,
  validateInputConctAddr,
} from '../../../auth/components/middleware/validate'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'

const Step6: any = ({eKYCRes, setActiveStep, setFieldValue}: any) => {
  const data = initialValues
  const parseDateDMY = (value?: string): Date | null => {
    if (!value) return null
    const m = moment(value, 'DD/MM/YYYY', true)
    return m.isValid() ? m.toDate() : null
  }

  const [valueIdno, setValueIdno] = useState(eKYCRes?.ocr?.object?.id)
  const [valueIdnoIssDt, setValueIdnoIssDt] = useState<Date | null>(
    parseDateDMY(eKYCRes?.ocr?.object?.issue_date) || new Date()
  )
  const [valueIdnoIssOrga, setValueIdnoIssOrga] = useState(eKYCRes?.ocr?.object?.issue_place)
  const [valueCustName, setValueCustName] = useState(eKYCRes?.ocr?.object?.name)
  const [valueBirth, setValueBirth] = useState<Date | null>(
    parseDateDMY(eKYCRes?.ocr?.object?.birth_day) || new Date()
  )
  const [valueHomeAdr, setValueHomeAdr] = useState(eKYCRes?.ocr?.object?.recent_location)
  const [valueContactAdd, setValueContractAdd] = useState(eKYCRes?.ocr?.object?.recent_location)
  const [checkedLocate, setCheckedLocate] = useState(data.accuracy)
  const [checkedGender, setCheckedGender] = useState(eKYCRes?.ocr?.object?.gender)
  const [textWarnIss, setTextWarnIss] = useState('')
  const [textWarnConctAddr, setTextWarnConctAddr] = useState('')
  const [textWarnIdnoOrga, setTextWarnIdnoOrga] = useState('')
  const [validateTick, setValidateTick] = useState('')
  const [checkFatca, setCheckFatca] = useState(data.fatca_yn)

  const handleCheckedLocation = (e: any) => {
    setCheckedLocate(e.target.checked)
    if (e.target.checked === true) {
      const temp = validateInputConctAddr(newLineToSpace(valueHomeAdr)) //check dia chi lien he co du 27 ki tu
      if (temp === false) {
        setValidateTick('Vui lòng bỏ tick để nhập đầy đủ')
      } else {
        setFieldValue('conct_addr', newLineToSpace(valueHomeAdr))
        setValidateTick('')
        setTextWarnConctAddr('')
        // setActiveStep(false)
      }
    } else {
      setValidateTick('')
      if (valueContactAdd) {
        const validateConct = validateInputConctAddr(newLineToSpace(valueContactAdd))
        if (validateConct === false) {
          setTextWarnConctAddr('Không được nhập khoảng trắng đầu, cuối và nhập đủ 27 ký tự')
          setActiveStep(true)
        } else {
          setTextWarnConctAddr('')
          // setActiveStep(false)
        }
      }
    }
  }

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.id) {
      setValueIdno(eKYCRes?.ocr?.object?.id)
      setFieldValue('idno', eKYCRes?.ocr?.object?.id)
    }
  }, [eKYCRes?.ocr?.object?.id, setFieldValue])

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.gender) {
      setCheckedGender(eKYCRes?.ocr?.object?.gender)
      setFieldValue('sex_tp', eKYCRes?.ocr?.object?.gender === 'Nam' ? '1' : '2')
    }
  }, [eKYCRes?.ocr?.object?.gender, setFieldValue])

  useEffect(() => {
    const parsed = parseDateDMY(eKYCRes?.ocr?.object?.issue_date)
    if (parsed) {
      setValueIdnoIssDt(parsed)
      setFieldValue('idno_iss_dt', moment(parsed).format('YYYY-MM-DD'))
    }
  }, [eKYCRes?.ocr?.object?.issue_date, setFieldValue])

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.issue_place) {
      setValueIdnoIssOrga(eKYCRes?.ocr?.object?.issue_place)
      setFieldValue('idno_iss_orga', newLineToSpace(eKYCRes?.ocr?.object?.issue_place))
    }
  }, [eKYCRes?.ocr?.object?.issue_place, setFieldValue])

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.name) {
      setValueCustName(eKYCRes?.ocr?.object?.name)
      setFieldValue('cust_nm', eKYCRes?.ocr?.object?.name)
    }
  }, [eKYCRes?.ocr?.object?.name, setFieldValue])

  useEffect(() => {
    const parsed = parseDateDMY(eKYCRes?.ocr?.object?.birth_day)
    if (parsed) {
      setValueBirth(parsed)
      setFieldValue('birth_dt', moment(parsed).format('YYYY-MM-DD'))
    }
  }, [eKYCRes?.ocr?.object?.birth_day, setFieldValue])

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.recent_location) {
      setValueHomeAdr(eKYCRes?.ocr?.object?.recent_location)
      setFieldValue('home_addr', newLineToSpace(eKYCRes?.ocr?.object?.recent_location))
    }
  }, [eKYCRes?.ocr?.object?.recent_location, setFieldValue])

  useEffect(() => {
    if (eKYCRes?.ocr?.object?.recent_location) {
      setValueContractAdd(eKYCRes?.ocr?.object?.recent_location)
      setFieldValue('conct_addr', newLineToSpace(eKYCRes?.ocr?.object?.recent_location))
    }
  }, [eKYCRes?.ocr?.object?.recent_location, setFieldValue])

  const handleChangeIdno = (val: Date | null) => {
    setValueIdnoIssDt(val)
  }

  const handleChangeBirth = (val: Date | null) => {
    setValueBirth(val)
  }

  const handleChangeValIdnoOrga = (val: any) => {
    setValueIdnoIssOrga(val)
    setFieldValue('idno_iss_orga', val)
    if (!val) {
      setActiveStep(true)
      setTextWarnIdnoOrga('')
    } else if (val) {
      const validateIdnoOrga = validateInput(val)
      if (validateIdnoOrga === false) {
        setTextWarnIdnoOrga('Không được nhập khoảng trắng đầu tiên và cuối cùng')
      } else if (validateIdnoOrga === true) {
        setTextWarnIdnoOrga('')
      }
    }
  }
  // valueIdnoIssOrga   valueHomeAdr   valueContactAdd
  const handleChangeValHomeAddr = (val: any) => {
    setValueHomeAdr(val)
    setFieldValue('home_addr', val)
    if (!val) {
      setActiveStep(true)
      setTextWarnIss('')
    } else if (val && !checkedLocate) {
      const validateIss = validateInput(val)
      if (validateIss === false) {
        setTextWarnIss('Không được nhập khoảng trắng đầu tiên và cuối cùng')
      } else if (validateIss === true) {
        setTextWarnIss('')
      }
    } else if (val && checkedLocate) {
      const validateConct = validateInputConctAddr(val)
      const validateIss = validateInput(val)
      if (validateIss === false) {
        setTextWarnIss('Không được nhập khoảng trắng đầu tiên và cuối cùng')
      } else if (validateIss === true) {
        setTextWarnIss('')
      }
      if (validateConct === false) {
        setTextWarnConctAddr('Không được nhập khoảng trắng đầu, cuối và nhập đủ 27 ký tự')
      } else if (validateConct === true) {
        setFieldValue('conct_addr', val)
        setTextWarnConctAddr('')
        setValidateTick('')
      }
    }
  }

  const handleChangeValConctAddr = (val: any) => {
    setValueContractAdd(val)
    if (!val) {
      setActiveStep(true)
      setTextWarnConctAddr('')
    } else if (val) {
      const validateConct = validateInputConctAddr(val)
      if (validateConct === false) {
        setTextWarnConctAddr('Không được nhập khoảng trắng đầu, cuối và nhập đủ 27 ký tự')
      } else if (validateConct === true) {
        setTextWarnConctAddr('')
      }
    }
  }

  const handleCheckedHaveRead = (e: any) => {
    setCheckFatca(e.target.checked)
    // if (e.target.checked === false) {
    //   setActiveStep(true)
    // } else {
    //   setActiveStep(false)
    // }
  }

  useEffect(() => {
    if (
      !textWarnIdnoOrga &&
      !textWarnIss &&
      !textWarnConctAddr &&
      !validateTick &&
      checkFatca &&
      valueIdno &&
      valueIdnoIssOrga &&
      checkedGender &&
      valueHomeAdr &&
      valueContactAdd
    ) {
      setActiveStep(false)
    } else {
      setActiveStep(true)
    }
  }, [
    checkFatca,
    checkedGender,
    setActiveStep,
    textWarnConctAddr,
    textWarnIdnoOrga,
    textWarnIss,
    validateTick,
    valueContactAdd,
    valueHomeAdr,
    valueIdno,
    valueIdnoIssOrga,
  ])

  return (
    <div className='w-100'>
      <div className='w-100'>
        <div className='pb-5 pb-lg-5'>
          <h2 className='fw-bolder text-primary text-center'>Xác nhận thông tin</h2>
        </div>
        <div className='text-center'>
          <div className='text-center'>
            <span className='d-block'>Vui lòng kiểm tra kết quả xác thực và xác nhận</span>
          </div>
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Số CMND/CCCD</label>

          <Field
            name='idno'
            placeholder='Nhập Số CMND/CCCD '
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <input
                className='form-control form-control-lg form-control-solid noactive'
                {...field}
                type='text'
                disabled
                value={valueIdno}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  setValueIdno(newEvent.target.value)
                  return field.onChange(newEvent)
                }}
              />
            )}
          </Field>
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Ngày cấp</label>

          <Field
            name='idno_iss_dt'
            placeholder='Nhập Ngày cấp'
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <DatePicker
                className='form-control form-control-lg form-control-solid'
                selected={
                  valueIdnoIssDt && moment(valueIdnoIssDt).isValid() ? valueIdnoIssDt : null
                }
                onKeyDown={(e) => e.preventDefault()}
                dateFormat='dd/MM/yyyy'
                onChange={(date: Date | null) => {
                  handleChangeIdno(date)
                  setFieldValue(
                    'idno_iss_dt',
                    date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : ''
                  )
                }}
              />
            )}
          </Field>
        </div>

        <div className='fv-row mb-10'>
          <label className='form-label'>Nơi cấp</label>

          <Field
            name='idno_iss_orga'
            placeholder='Nhập Nơi cấp '
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <input
                className='form-control form-control-lg form-control-solid'
                {...field}
                type='text'
                value={valueIdnoIssOrga && newLineToSpace(valueIdnoIssOrga)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  handleChangeValIdnoOrga(newEvent.target.value)
                  return field.onChange(newEvent)
                }}
              />
            )}
          </Field>
          {textWarnIdnoOrga && <span className='text-danger'>{textWarnIdnoOrga}</span>}
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Họ và tên</label>

          <Field
            name='cust_nm'
            placeholder='Nhập Họ và tên '
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <input
                className='form-control form-control-lg form-control-solid noactive'
                {...field}
                type='text'
                disabled
                value={valueCustName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  setValueCustName(newEvent.target.value)
                  return field.onChange(newEvent)
                }}
              />
            )}
          </Field>
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Ngày sinh</label>
          <Field
            name='birth_dt'
            placeholder='Nhập Ngày sinh'
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <DatePicker
                className='form-control form-control-lg form-control-solid'
                selected={valueBirth && moment(valueBirth).isValid() ? valueBirth : null}
                onKeyDown={(e) => e.preventDefault()}
                dateFormat='dd/MM/yyyy'
                onChange={(date: Date | null) => {
                  handleChangeBirth(date)
                  setFieldValue(
                    'birth_dt',
                    date && moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : ''
                  )
                }}
              />
            )}
          </Field>
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Giới tính</label>

          <div className='d-flex w-full justify-content-between'>
            <div className='d-flex mt-4 '>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input cursor-pointer'
                  type='radio'
                  name='sex_tp'
                  value='1'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <input
                      className='form-check-input'
                      {...field}
                      type='radio'
                      checked={checkedGender === 'Nam'}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        setCheckedGender(e.target.value === '1' ? 'Nam' : 'Nữ')
                        return field.onChange(newEvent)
                      }}
                    />
                  )}
                </Field>
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Nam</span>
              </span>
            </div>
            <div className='d-flex mt-4'>
              <span className='form-check form-check-custom form-check-solid'>
                <Field
                  className='form-check-input cursor-pointer'
                  type='radio'
                  name='sex_tp'
                  value='2'
                >
                  {({field, form: {touched, errors}}: any) => (
                    <input
                      className='form-check-input'
                      {...field}
                      type='radio'
                      checked={checkedGender === 'Nữ'}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let newEvent = e
                        setCheckedGender(e.target.value === '2' ? 'Nữ' : 'Nam')
                        return field.onChange(newEvent)
                      }}
                    />
                  )}
                </Field>
              </span>
              <span className='d-flex flex-column mx-4'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>Nữ</span>
              </span>
            </div>
          </div>
        </div>

        <div className='fv-row mt-7 mb-5'>
          <label className='fs-6 fw-bold form-label'>Địa chỉ thường trú</label>

          <Field
            name='home_addr'
            placeholder='Nhập Địa chỉ thường trú'
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <input
                className='form-control form-control-lg form-control-solid'
                {...field}
                type='text'
                value={valueHomeAdr && newLineToSpace(valueHomeAdr)}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  handleChangeValHomeAddr(newEvent.target.value)
                  return field.onChange(newEvent)
                }}
              />
            )}
          </Field>
          {textWarnIss && <span className='text-danger'>{textWarnIss}</span>}
        </div>

        <div className='fv-row mt-5 mb-5'>
          <label className='fs-6 fw-bold form-label'>Địa chỉ liên hệ</label>

          <Field
            name='conct_addr'
            placeholder='Nhập Địa chỉ liên hệ'
            className='form-control form-control-lg form-control-solid'
          >
            {({field, form: {touched, errors}}: any) => (
              <input
                className={`form-control form-control-lg form-control-solid ${
                  checkedLocate ? 'noactive' : ''
                }`}
                {...field}
                type='text'
                disabled={checkedLocate}
                value={
                  checkedLocate
                    ? valueHomeAdr && newLineToSpace(valueHomeAdr)
                    : valueContactAdd && newLineToSpace(valueContactAdd)
                }
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  let newEvent = e
                  handleChangeValConctAddr(newEvent.target.value)
                  return field.onChange(newEvent)
                }}
              />
            )}
          </Field>
          {textWarnConctAddr && <p className='text-danger'>{textWarnConctAddr}</p>}
          {validateTick ? <p className='text-danger'>{validateTick}</p> : null}
        </div>
        <div>
          <div className='fv-row mt-4'>
            <div className='d-flex align-items-center mt-3'>
              <label className='form-check form-check-inline form-check-solid me-5 text-hover-primary'>
                <Field
                  type='checkbox'
                  name='accuracy'
                  className='form-check-input w-25px h-25px'
                  onClick={handleCheckedLocation}
                />
                <span className='fw-bold ps-2 fs-6'>
                  Địa chỉ liên hệ trùng với địa chỉ thường trú
                </span>
              </label>
            </div>
          </div>
          <div className='fv-row'>
            <div className='d-flex align-items-center mt-3'>
              <label className='form-check form-check-inline form-check-solid me-5 text-hover-primary'>
                <Field
                  className='form-check-input'
                  type='checkbox'
                  name='fatca_yn'
                  onClick={handleCheckedHaveRead}
                />
                <span className='fw-bold ps-2 fs-6'>
                  Tôi không thuộc các trường hợp là công dân Mỹ hoặc đối tượng cư trú tại Mỹ, có nơi
                  sinh/địa chỉ nhận thư hoặc địa chỉ lưu trú/số điện thoại liên lạc/địa chỉ nhận thư
                  hộ hoặc giữ thư tại Mỹ.
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export {Step6}
